import script from "./drafts.vue?vue&type=script&lang=ts&setup=true"
export * from "./drafts.vue?vue&type=script&lang=ts&setup=true"

import "./drafts.vue?vue&type=style&index=0&id=23e9802a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23e9802a"]])

export default __exports__